@if (categories && categories.length > 1) {
  <div
    [ngClass]="{'dropdown__mobile': isMobile}"
    id="dropdown">
    <button type="button" class="dropdown__base-container" (click)="toggleDropdown()">
      <span class="dropdown__base-header-text" [attr.data-testid]="headerText + 'dropdown'">{{headerText}}</span>
      <span class="dropdown__category" data-testid="selected-dropdown-option">{{selectedCategory}}</span>
      <mat-icon matSuffix class="dropdown__chevron-closed">expand_more</mat-icon>
    </button>
    @if (dropdownOpen && !isMobile) {
      <div class="dropdown__expanded-container" id="expanded-dropdown">
        <div class="dropdown__expanded-header-text">{{headerText}}</div>
        <mat-icon matSuffix class="dropdown__chevron-open">expand_less</mat-icon>
        @for (category of categories; track category; let i = $index; let isLast = $last) {
          <div
            class="dropdown__row-hover"
            [ngClass]="{'dropdown__selected-category': category === selectedCategory}">
            <button type="button" class="dropdown__categories" (click)="selectCategory(category)" [attr.data-testid]="'dropdown-option-' + i">{{category}}</button>
            @if (!isLast) {
              <hr>
              }
            </div>
          }
        </div>
      }
      @if (dropdownOpen && isMobile) {
        <button
          type="button"
          class="dropdown__mobile-slide-up"
          [attr.aria-label]="headerText"
          (click)="openMobileCategories()">
        </button>
      }
    </div>
  }
